export const statusList = [
    { label: "Selecione", value: "" },
    { label: "Esperando", value: "waiting" },
    { label: "Aprovado", value: "approved" },
    { label: "Rejeitado", value: "rejected" },
]